import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import PersonIcon from '../../../shared/components/Icons/Person';
import PlaceIcon from '../../../shared/components/Icons/Place';

import containerWidth from '../../../shared/helpers/containerWidth';

import './DetailsSubHeader.scss';
import safeValue from '../../../shared/helpers/safeValue';

const DetailsSubHeader = ({ address, borrower }) => (
  <div className="row details_sub_header">
    <div className={containerWidth}>
      <div className="row">
        <div className="details_sub_header__icon_col">
          <PlaceIcon
            className="details_sub_header__icon"
            width={55}
            height={55}
          />
        </div>
        <div className="col-10 col-md-4">
          <div className="row">
            <div className="col-12 details_sub_header__title text-truncate">
              {address?.address1}
              {' '}
              {safeValue(address?.address2)}
            </div>
            <div className="col-12 details_sub_header__text text-truncate">
              {address?.city}
              ,
              {address?.state}
              {' '}
              {address?.zipCode}
            </div>
          </div>
        </div>
        {borrower && (
          <>
            <div className="details_sub_header__divider d-none d-xl-block" />
            <div className="details_sub_header__icon_col">
              <PersonIcon
                className="details_sub_header__icon"
                width={55}
                height={55}
              />
            </div>
            <div className="col-10 col-md-4 align-self-center align-items-center">
              <div className="details_sub_header__title text-truncate">{borrower}</div>
            </div>
          </>
        )}
      </div>
    </div>
  </div>
);

DetailsSubHeader.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  address: PropTypes.object,
  borrower: PropTypes.string,
};
DetailsSubHeader.defaultProps = {
  borrower: null,
  address: {},
};

const selector = formValueSelector('WizardOrderForm');
const DetailsSubHeaderWithState = connect((state) => {
  const address = selector(state, 'address');
  const borrower = selector(state, 'propertyOwner.companyName');
  return {
    address,
    borrower,
  };
})(DetailsSubHeader);

export default DetailsSubHeaderWithState;
